import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import './App.css';
import { SWRConfig } from 'swr';
import { ConfigProvider, Layout, theme, Typography } from 'antd';
import { BrowserRouter, Link, Route, Routes, useNavigate } from 'react-router';
import Home from './Home';
import { Menu } from 'antd';
import { Content, Footer, Header } from 'antd/es/layout/layout';
import Live from './Live';
import FAQ from './components/FAQ';

const logo = process.env.PUBLIC_URL + '/logo.png';

function NanospeedMenu() {
  const navigate = useNavigate();
  const [selectedKeys, setSelectedKeys] = useState(
    [window.location.pathname.split('/')[1] || '']
  );

const items = [
  {
    label: <Link
      to="/stats"
    >Stats</Link>,
    key: 'stats',
  },
  {
    label: <Link
      to="/live"
    >Live</Link>,
    key: 'live',
    
  },
  {
    key: 'about',
    label: <Link
      to="/about"
    >About</Link>
  },
]

  return (<>
  <div 
    onClick={() => {
      navigate('/');
      setSelectedKeys([]);
    }}
    style={{display: 'flex', alignItems: 'center', alignContent: 'center', color: 'white', cursor: 'pointer', marginRight: 4, fontSize: 16, fontWeight: 500}}>
      <img src={logo} width={32} alt='nanospeed_logo' style={{marginRight: 8}}/>
      <b>NanoSpeed</b>
      </div>
     <Menu
     theme='dark'
     style={{ flex: 1, minWidth: 0 }}
    selectedKeys={selectedKeys}
    onClick={(e) => {
      setSelectedKeys([e.key]);
      navigate(`/${e.key}`);
    }}
         mode="horizontal" items={items} />
</>
  );
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
    // theme={{algorithm: theme.darkAlgorithm}}
    >
      <SWRConfig 
      value={{
        fetcher: (resource, init) => fetch(process.env.REACT_APP_API + resource, init).then(res => res.json()).then(res => {
          if (res.error) {
            throw new Error(res.error);
          }
          return res;
        })
      }}
      >
        <BrowserRouter>
        <Layout>
      <Header style={{ display: 'flex', alignItems: 'center' }}>
       <NanospeedMenu />
       </Header>
        <Content style={{ minHeight: 'calc(100dvh - 64px - 168px)' }}>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/stats" element={<App />} />
        <Route path="/live" element={<Live />} />
        <Route path="/about" element={<FAQ />} />
        </Routes>
        </Content>
         <Footer style={{ textAlign: 'center' }}>
           <Typography.Paragraph style={{ fontSize: 26, marginBottom: 8, marginTop: 8, textAlign: "center" }}>
          <a href="https://x.com/nanospeedInfo" target="_blank">
              𝕏
          </a>
          </Typography.Paragraph>
          <br/>
          Powered by <a href="https://nanswap.com/nodes" target='_blank'>Nanswap Nodes</a><br />
          <div style={{marginTop: 6}}>
        NanoSpeed © {new Date().getFullYear()} </div>
      </Footer>
        </Layout>
        </BrowserRouter>
      </SWRConfig>
      </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
